import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import config from "../amplifyconfiguration.json";
import { onCreateProyectoCustom } from "../graphql/utils/extends";
import { iDataProyectoDynamoDB, iDataResultadoDynamoDB } from "../interfaces/iDataProyectoDynamoDB";
import { GetResultadoByProyectoId } from "./ApiGraphql";
import { onUpdateResultado } from "../graphql/subscriptions";

Amplify.configure(config);

const client = generateClient();

// Función para reintentar la obtención del resultado
const retryGetResultadoByProyectoId = async (proyectoId: string, retries = 5, delay = 3000) => {
  for (let i = 0; i < retries; i++) {
    try {
      const result = await GetResultadoByProyectoId(proyectoId);
      if (result) {
        return result;
      }
    } catch (error) {
      console.error(`Intento ${i + 1} fallido:`, error);
    }
    await new Promise((resolve) => setTimeout(resolve, delay));
  }
  throw new Error("No se pudo obtener el resultado después de varios intentos");
};

// Cambiar la suscripción para retornar una promesa
export const suscribeOnCreateProyecto = (userId: string): Promise<iDataProyectoDynamoDB> => {
  return new Promise((resolve, reject) => {
    try {
      // Nos suscribimos a la creación de nuevos proyectos solo para el usuario específico
      const subscription = client.graphql({
        query: onCreateProyectoCustom,
        variables: {
          filter: {
            usuarioId: { eq: userId },  // Filtramos los eventos por el userId
          }
        }
      });

      if ('subscribe' in subscription) {
        subscription.subscribe({
          next: ({ data }) => {
            const proyecto = data.onCreateProyecto;
            const proyectoId = proyecto?.id;
            if (proyectoId) {
              // Esperar por el resultado relacionado con el proyecto recién creado
              retryGetResultadoByProyectoId(proyectoId)
                .then((result) => {
                  proyecto.resultados = result;
                  console.log("resultado obtenido de la suscripción", proyecto);
                  resolve(proyecto);
                })
                .catch((error) => {
                  console.error("Error al obtener el resultado:", error);
                  proyecto.resultados = [];
                  resolve(proyecto);
                });
            } else {
              console.log("resultado obtenido de la suscripción", proyecto);
              resolve(proyecto);
            }
          },
          error: (error) => {
            console.warn(error);
            reject(error); // Rechazamos la promesa en caso de error
          },
        });
      }
    } catch (error) {
      console.error("Error en suscripción a nuevos proyectos:", error);
      reject(error); // Rechazamos la promesa en caso de error
    }
  });
};


export const suscribeOnUpdateResult = async (proyectoId:string):Promise<iDataResultadoDynamoDB>=>{
  return new Promise((resolve, reject) => {
    try {
      // Nos suscribimos a la actualizacion de resultados obtenidos por el proyectoId
      const subscription = client.graphql({
        query: onUpdateResultado,
        variables: {
          filter: {
            proyectoId: { eq: proyectoId },  // Filtramos los eventos por el proyectoId
          }
        }
      });

      if ('subscribe' in subscription) {
        subscription.subscribe({
          next: ({ data }) => {
            console.log("cambio en resultado", data);
            resolve(data.onUpdateResultado);
          },
          error: (error) => {
            console.warn(error);
            reject(error); // Rechazamos la promesa en caso de error
          },
        });
      }
    } catch (error) {
      console.error("Error en suscripción a resultado:", error);
      reject(error); // Rechazamos la promesa en caso de error
    }
  });
  

}